import { RAISE_API_V1_URL } from "constants/endpoints";
import { get } from "services/api";

export const getReceipt = async ({ orderNumber }) => {
  const response = await get(`${RAISE_API_V1_URL}/orders/${orderNumber}`);

  return response.data;
};
